<ng-container *ngIf="message">
  <ng-container *ngIf="(track && message.length > 320) || (!track && message.length > 320); else noSlice">
    <span [ngClass]="{ 'ad': !track, 't2': track }">{{ message | slice:0:(track ? 320 : 320) }}...</span>
  </ng-container>
  <ng-template #noSlice>
    <span [ngClass]="{
    'ad': !track && message.length > 120,
    't1': track && message.length > 140 && message.length <= 280,
    't2': track && message.length > 280
    }">
      {{ message }}
    </span>
  </ng-template>
</ng-container>
